import { render, staticRenderFns } from "./GroupQualityControl.vue?vue&type=template&id=01210c79&scoped=true"
import script from "./GroupQualityControl.vue?vue&type=script&lang=js"
export * from "./GroupQualityControl.vue?vue&type=script&lang=js"
import style0 from "./GroupQualityControl.vue?vue&type=style&index=0&id=01210c79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01210c79",
  null
  
)

export default component.exports